let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5oPus")).then(() => parcelRequire('1YfCq'));